export default "__VITE_ASSET__765315c5__"